import { TimelineMax } from '@/vendor';

export default {
    mounted()
    {
        this.starTwinkle = new TimelineMax();
        this.starTwinkle.fromTo( '.star-2', 0.75, { rotation: 0, autoAlpha: 0, scale: 0 }, { rotation: 360, autoAlpha: 1, scale: 0.8, repeat: -1, yoyo: true }, 0 );
        this.starTwinkle.fromTo( '.star-1', 0.75, { rotation: 0, autoAlpha: 0, scale: 0 }, { rotation: 180, autoAlpha: 1, scale: 1.5, repeat: -1, yoyo: true }, 0.5 );
        this.starTwinkle.fromTo( '.star-3', 0.75, { rotation: 0, autoAlpha: 0, scale: 0 }, { rotation: 90, autoAlpha: 1, scale: 1, repeat: -1, yoyo: true }, 0.25 );
    }
};
